export const themeConfig = {
    temp1: {
        type: 'box',
        servicesType: 'box',
        margin: '0px 16px 14px',
        padding: '20px',
        bgColor: '#212121',
        borderRadius: '6px',
        boxShadow: '0px 4px 74px 0px #00000012',
        textColor: '#FFF',
        headingAlign: 'left',
        btnColor: '#DE3036',
        ctaArrow: '#FFF'
    },
    temp2: {
        type: 'box',
        portfolioType: 'open',
        servicesType: 'open',
        margin: '30px 25px',
        padding: '20px',
        bgColor: '#FFF',
        textColor: '#000',
        btnColor: '#343C99',
        ctaArrow: '#FFF'
    },
    temp3: {
        type: 'box',
        servicesType: 'box',
        margin: '23px',
        padding: '30px',
        bgColor: '#F1F1EE',
        textColor: '#000',
        headingAlign: 'left',
        borderRadius: '14px',
        btnColor: 'linear-gradient(99.5deg, #FF441B -20.5%, #FF9635 112.82%), linear-gradient(0deg, rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.05));',
        ctaArrow: '#FFF'
    },
    temp4: {
        type: 'box',
        portfolioType: 'open',
        servicesType: 'open',
        margin: '0 16px 14px',
        padding: '15px 30px',
        bgColor: '#0165FC',
        headingColor: '#FFF',
        portfolioHeadingColor: '#303030',
        textColor: '#FFF',
        btnColor: '#FFC708',
        headingAlign: 'left',
        ctaArrow: '#000'
    },
    temp5: {
        type: 'box',
        servicesType: 'box',
        margin: '30px 15px',
        padding: '25px 30px',
        bgColor: '#2f3438',
        textColor: '#FFF',
        borderRadius: '10px',
        boxShadow: '0 4px 24px 0 rgba(0, 0, 0, 0.3)',
        btnColor: '#6B86FF',
        ctaArrow: '#FFF'
    },
    temp6: {
        type: 'open',
        portfolioType: 'open',
        servicesType: 'box',
        margin: '',
        padding: '30px',
        bgColor: '#FFF',
        secBgColor: '',
        headingColor: '#000',
        textColor: '#000',
        btnColor: '#FFC708',
    },
    temp7: {
        type: 'open',
        portfolioType: 'open',
        margin: '23px 12px',
        padding: '10px 15px',
        bgColor: '#212121',
        secBgColor: '',
        textColor: '#FFF',
        headingAlign: 'left',
        btnColor: '#1BBFA2',
    },
    temp9: {
        type: 'box',
        margin: '20px 15px',
        padding: '20px',
        bgColor: 'linear-gradient(0deg, #201619, #201619), linear-gradient(0deg, #562435, #562435)',
        borderRadius: '5px',
        textColor: '#FFF',
        btnColor: '#672038',
        ctaArrow: '#FFF',
        // innerTestimonialBg: 'linear-gradient(270deg, rgba(229, 49, 110, 0) 0%, rgba(229, 49, 110, 0.36) 23.32%, rgba(229, 49, 110, 0.36) 79.61%, rgba(229, 49, 110, 0) 101.41%)'
    },
    temp11: {
        type: 'open',
        portfolioType: 'open',
        servicesType: 'open',
        margin: '0 40px 40px',
        bgColor: 'transparent',
        secBgColor: '#FFF',
        textColor: '#FFF',
        btnColor: '#FFF',
        ctaArrow: '#000'
    },
    temp15: {
        type: 'open',
        portfolioType: 'open',
        margin: '',
        padding: '0px 25px 32px',
        bgColor: '#FFFAEC',
        textColor: '#FFA438',
        ctaArrow: '#9E621C',
        btnColor: '#FFA438'
    },
    temp16: {
        type: 'open',
        portfolioType: 'open',
        servicesType: 'open',
        margin: '16px 23px',
        padding: '',
        bgColor: '#254091',
        textColor: '#FFF',
        headingAlign: 'left',
        ctaArrow: '#FFF',
        btnColor: '#D1001A',
    },
    temp17: {
        type: 'box',
        margin: '23px',
        padding: '16px 12px',
        bgColor: 'linear-gradient(88.9deg, rgb(11, 26, 57) 0.84%, rgb(15, 15, 15) 98.97%)',
        textColor: '#FFF',
        headingAlign: 'left',
        btnColor: '#D58F2D',
    },
    temp18: {
        type: 'open',
        portfolioType: 'box',
        servicesType: 'box',
        margin: '0px 18px 30px',
        bgColor: '#FFF',
        secBgColor: '#E4F2FF',
        boxShadow: '0px 2px 5px 0px #00000059',
        textColor: '#000',
        headingAlign: 'left',
        btnColor: '#1C85E7',
    },
    temp27: {
        type: 'open',
        servicesType: 'open',
        margin: '0px 18px',
        padding: '30px 0 0 0',
        bgColor: '#1D1D1D',
        secBgColor: '#2B2B2B',
        textColor: '#FFF',
        btnColor: '#292929',
        headingAlign: 'left',
        // boxShadow: '1px 1px 0px 0px'
    },
    temp28: {
        type: 'open',
        portfolioType: 'box',
        servicesType: 'box',
        margin: '0px 18px 25px',
        padding: '20px 25px',
        bgColor: '#FFF',
        secBgColor: '#37686C',
        textColor: '#000',
        boxShadow: '0px 4px 24px 0px #0000001F',
        btnColor: '#37686C',
    },
    temp29: {
        type: 'open',
        portfolioType: 'open',
        servicesType: 'open',
        margin: '',
        padding: '0 25px 32px',
        bgColor: '#F8F8F8',
        secBgColor: '#9EAFB7',
        textColor: '#000',
        btnColor: '#9EAFB7',
    },
    temp30: {
        type: 'box',
        margin: '30px 15px',
        servicesType: 'box',
        padding: '15px 30px',
        bgColor: '#022A51',
        textColor: '#FFF',
        btnColor: '#1970D1',
        borderRadius: '10px',
    },
    temp31: {
        type: 'open',
        portfolioType: 'open',
        margin: '',
        padding: '30px',
        bgColor: '#F8F8F8',
        secBgColor: '#40A8B4',
        headingColor: '#000',
        textColor: '#000',
        btnColor: '#40A8B4',
    },
    temp32: {
        type: 'box',
        margin: '0px 18px 24px',
        servicesType: 'box',
        padding: '20px 25px',
        bgColor: '#F1F1EE',
        textColor: '#000',
        btnColor: '#1B1F4D',
        headingAlign: 'left',
        ctaArrow: '#F1F1EE'
    },
    temp33: {
        type: 'box',
        servicesType: 'box',
        margin: '23px',
        padding: '20px',
        bgColor: '#F8F8F8',
        textColor: '#000',
        btnColor: '#CD3C1F',
        headingAlign: 'left',
        ctaArrow: '#F8F8F8'
    },
    temp34: {
        type: 'open',
        servicesType: 'box',
        portfolioType: 'box',
        margin: '0px 18px 25px',
        padding: '20px 25px',
        bgColor: '#FFF',
        secBgColor: '#CE840F',
        textColor: '#000',
        btnColor: '#CE840F',
        boxShadow: '0px 4px 24px 0px #0000001F',
    },
    temp35: {
        type: 'open',
        servicesType: 'open',
        margin: '23px 18px',
        padding: '20px',
        bgColor: '#FFFFFF4D',
        secBgColor: '#303030',
        headingColor: '#000',
        headingAlign: 'left',
        textColor: '#000',
        btnColor: '#303030',
        ctaArrow: '#E3E3E3'
    },
    temp36: {
        type: 'open',
        portfolioType: 'open',
        servicesType: 'open',
        margin: '0px 20px 24px',
        padding: '0',
        bgColor: '#FFF',
        secBgColor: '#815738',
        textColor: '#332518',
        btnColor: '#815738',
    },
    temp37: {
        type: 'box',
        portfolioType: 'open',
        margin: '',
        padding: '30px',
        bgColor: '#0F2E8B',
        headingColor: '#FFF',
        textColor: '#FFF',
        portfolioHeadingColor: '#303030',
        headingAlign: 'left',
        btnColor: '#FFF',
        ctaArrow: '#0F2E8B'
    },
    temp38: {
        type: 'box',
        margin: '0px 16px 14px',
        padding: '20px',
        bgColor: '#815738',
        headingColor: '#F0E4CE',
        textColor: '#F0E4CE',
        btnColor: '#FFF',
        headingAlign: 'left',
        ctaArrow: '#815738'
    },
    temp39: {
        type: 'box',
        portfolioType: 'open',
        margin: '',
        padding: '30px',
        bgColor: '#F8F8F8',
        headingColor: '#000',
        textColor: '#000',
        btnColor: '#18BAE1',
    },
    temp40: {
        type: 'open',
        portfolioType: 'open',
        margin: '',
        padding: '0 30px 30px 30px',
        bgColor: '#242424',
        secBgColor: '#383838',
        textColor: '#FFF',
        btnColor: '#383838',
    },
    temp41: {
        type: 'open',
        portfolioType: 'open',
        margin: '0px 18px 30px',
        padding: '15px 13px',
        bgColor: '#FFF',
        // secBgColor: '#1A110C',
        secBgColor: '#D25400',
        textColor: '#1E1E1E',
        btnColor: '#D25400',
        headingAlign: 'left',
        // ctaArrow: '#FFF',
        boxShadow: '0px 2px 5px 0px #0000004D'
    },
    temp42: {
        type: 'box',
        margin: '23px',
        padding: '30px',
        bgColor: '#F1F1EE',
        textColor: '#202020',
        btnColor: '#495057',
        headingAlign: 'left',
        ctaArrow: '#F1F1EE'
    },
    temp43: {
        type: 'open',
        portfolioType: 'box',
        margin: '0px 18px 25px',
        padding: '20px 25px',
        bgColor: '#FFF',
        secBgColor: '#9BC61E',
        textColor: '#1E1E1E',
        btnColor: '#9BC61E',
        boxShadow: '0px 4px 24px 0px #0000001F'
    },
    temp44: {
        type: 'open',
        portfolioType: 'open',
        margin: '',
        padding: '0 25px 32px 25px',
        bgColor: '#F8F8F8',
        secBgColor: '#0B7636',
        textColor: '#000',
        btnColor: '#0B7636',
        ctaArrow: '#FFF9F9'
    },
    temp45: {
        type: 'box',
        margin: '30px 15px',
        padding: '25px 30px',
        bgColor: '#2F3438',
        textColor: '#FFF',
        btnColor: '#42464A',
        borderRadius: '10px',
    },
    temp46: {
        type: 'open',
        portfolioType: 'box',
        margin: '0px 18px 24px',
        padding: '20px 0 0 0',
        bgColor: '#FFF',
        secBgColor: '#C01E2E',
        textColor: '#1E1E1E',
        btnColor: '#C01E2E',
        boxShadow: '0px 4px 24px 0px #0000001F'
    },
    temp47: {
        type: 'box',
        portfolioType: 'open',
        margin: '',
        padding: '15px 30px',
        bgColor: '#F45B1F',
        headingColor: '#FFF',
        portfolioHeadingColor: '#000',
        textColor: '#FFF',
        btnColor: '#1F2024',
        headingAlign: 'left'
    },
    temp48: {
        type: 'open',
        portfolioType: 'box',
        margin: '0px 18px 30px',
        bgColor: '#FFF',
        secBgColor: '#E4E7DB',
        textColor: '#1E1E1E',
        btnColor: '#E7B91C',
        headingAlign: 'left',
        boxShadow: '0px 2px 5px 0px #0000004D',
    },
    temp49: {
        type: 'box',
        portfolioType: 'open',
        margin: '30px 25px',
        padding: '20px',
        bgColor: '#FFF',
        textColor: '#000',
        btnColor: '#349938',
        ctaArrow: '#FFF'
    },
    temp50: {
        type: 'box',
        margin: '30px 15px',
        padding: '25px',
        bgColor: '#293228',
        textColor: '#FFF',
        btnColor: 'linear-gradient(90deg, rgb(158, 189, 19) 0%, rgb(0, 133, 82) 100%)',
        ctaArrow: '#FFF',
        borderRadius: '10px',
    },
    temp51: {
        type: 'open',
        margin: '23px 18px',
        padding: '20px',
        bgColor: '#FFFFFF4D',
        secBgColor: '#645244',
        headingColor: '#000',
        headingAlign: 'left',
        textColor: '#000',
        btnColor: '#645244',
        ctaArrow: '#FFAD7E'
    },
    temp52: {
        type: 'open',
        portfolioType: 'open',
        margin: '',
        padding: '0 25px 32px',
        bgColor: '#FFF',
        secBgColor: '#9EAFB7',
        textColor: '#000',
        btnColor: '#9EAFB7',
    }
}